import { useEffect, useState } from 'react'
import { useApiQuery } from 'grabbitbot-legacy-ui'
import { connections } from '../../api/fee'
import type { ConnectionSettings } from '../../api/types'
import { Notice, PageTitle, QueryState } from '../../components/common'
import { useProject } from '../../layout/projectContext'
import { useMoneyAction } from '../../lib/useMoneyAction'

/** Port of `ConnectionsettingsComponent` (`projects/:projectId/connection-settings`):
 * whether the caller shares their Telegram connection with this project
 * (`GET|PATCH …/connectionsettings`). */
export function ConnectionSettingsPage() {
  const { projectId, project } = useProject()
  const q = useApiQuery(() => connections.settings(projectId), [projectId])
  const [settings, setSettings] = useState<ConnectionSettings | null>(null)
  const actions = useMoneyAction()
  useEffect(() => {
    if (q.data) setSettings(q.data)
  }, [q.data])

  const save = async () => {
    if (!settings) return
    const body = { ...settings, telegramShared: settings.telegramShared ? 1 : 0 } as ConnectionSettings
    const r = await actions.run('save', JSON.stringify(body), () => connections.modifySettings(projectId, body))
    if (r) {
      actions.setFeedback('save', { tone: 'success', text: 'Saved.' })
      q.refetch()
    }
  }

  return (
    <div className="portal-card portal-card--profile">
      <PageTitle title="Connection settings" />
      <QueryState loading={q.loading && !settings} error={q.error}>
        {settings && (
          <form
            className="portal-form"
            onSubmit={(e) => {
              e.preventDefault()
              void save()
            }}
          >
            <label className="fs-switch">
              <input
                type="checkbox"
                role="switch"
                checked={Boolean(settings.telegramShared)}
                onChange={(e) => setSettings({ ...settings, telegramShared: e.target.checked ? 1 : 0 })}
              />
              Share Telegram connection with project &apos;{project.name}&apos;? {settings.telegramShared ? 'Yes' : 'No'}
            </label>
            <button type="submit" disabled={actions.isBusy('save')}>
              {actions.isBusy('save') ? 'Saving…' : 'Save'}
            </button>
            <Notice feedback={actions.feedbackFor('save')} />
          </form>
        )}
      </QueryState>
    </div>
  )
}
